import "moment-timezone";
import React from "react";
import 'react-block-ui/style.css';
import { Route, useParams } from 'react-router';
import ContactsListView from './ContactsListView';

const Contacts = () => {
    const { view } = useParams()

    return (
          <div>
            <h1 className="first-title" style={{ marginBottom: '20px' }}>
              Contacts
            </h1>
            <Route path={'/m1/contacts/list/:view'} render={(props) => <ContactsListView view={view} {...props} />} />


          </div>

    );

}
export default Contacts;
